var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice",class:{ subscribed: _vm.subscribed },on:{"click":_vm.notice}},[_c('i',{staticClass:"i"}),_c('span',[_vm._v(_vm._s(_vm.subscribed ? '已开启上新提醒' : '上新及时通知我'))])])}
var staticRenderFns = []

export { render, staticRenderFns }